import axios, { AxiosResponse } from "axios";
import { GetCurrentAlertsRequest, GetCurrentAlertsResponse } from "../typeDef/alertBanner.model";

export async function getCurrentAlerts(params: GetCurrentAlertsRequest): Promise<AxiosResponse<GetCurrentAlertsResponse>> {
    return await axios.get<GetCurrentAlertsRequest, AxiosResponse<GetCurrentAlertsResponse>>
        (`${process.env.REACT_APP_API_BASE_URL}/alert-banner/current`, { params });
}